import { useLocation } from 'react-router';
import { StickyCopyExtension } from 'common/StickyCopyExtension/StickyCopyExtension';
import React from 'react';
import { CellLayout, CellLayoutLinkTypography } from './CellLayout';

export type StickyLinkCellProps = {
  value: string;
  to: string;
};

export const StickyLinkCell: React.FC<StickyLinkCellProps> = React.memo(({ value, to }) => {
  const { pathname, search } = useLocation();
  return (
    <CellLayout>
      <StickyCopyExtension value={value}>
        <CellLayoutLinkTypography to={to} state={{ previousPath: `${pathname}${search}` }}>
          {value}
        </CellLayoutLinkTypography>
      </StickyCopyExtension>
    </CellLayout>
  );
});
